module.exports = __webpack_public_path__ + "static/media/Accuracy.7c7415a5.svg";